import { Box, Card, IconButton } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import Flx from "../../../layout/Flx";
import {
  ChatOutlined,
  CloseRounded,
  ExpandRounded,
  MinimizeOutlined,
} from "@mui/icons-material";
import Txt from "../../../typography/Txt";
import { size } from "lodash";
import LoanEnhancedCommentTextBox from "../LoanEnhancedCommentTextBox";
import EnhancedCommentItemRenderer from "../../../../_src_shared/comments/EnhancedCommentItemRenderer";

const PinnedCommentsModal = ({
  show,
  onClose,
  fileId,
  height = "680px",
  comments,
  borrowerIds,
  subjectPropertyIds,
  title = "Comments",
  documentIds,
  fixed = false,
  loan,
}) => {
  const [collapsed, setCollapsed] = useState(false);
  const [commentsList, setCommentsList] = useState(null);
  const offset = useMemo(() => 36, []);

  // console.log("PINNED", comments, borrowerIds, subjectPropertyIds);
  useEffect(() => {
    // console.log("borr", borrowerIds);
    setCommentsList(comments);
  }, [comments]);
  if (!show) return null;
  return (
    <Card
      sx={{
        boxShadow: 20,
        position: fixed ? "fixed" : "absolute",
        bottom: 0,
        right: offset,
        p: 0,
        zIndex: 2000,
        width: `calc(100% - ${offset * 2}px)`,
        maxWidth: collapsed ? "325px" : `540px`,
        display: "flex",
        flexDirection: "column",
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      }}
    >
      <Flx fw jb ac sx={{ flexGrow: 0, p: 1 }}>
        <Flx ac gap={0.5}>
          <ChatOutlined sx={{ fontSize: "16px", ml: 1 }} className="thin" />
          <Txt bold>
            {title} ({size(commentsList)})
          </Txt>
        </Flx>
        <Flx ac>
          <IconButton onClick={() => setCollapsed((s) => !s)} size="small">
            {collapsed ? <ExpandRounded /> : <MinimizeOutlined />}
          </IconButton>
          <IconButton onClick={onClose} size="small">
            <CloseRounded />
          </IconButton>
        </Flx>
      </Flx>
      <Flx
        column
        sx={{
          overflowY: "auto",
          flexGrow: 1,
          height: collapsed ? 0 : height,
          maxHeight: "68vh",
          pb: collapsed ? 0 : 2,
          transition: "60ms ease-in-out",
        }}
      >
        <Box sx={{ px: 2 }}>
          <LoanEnhancedCommentTextBox
            loan={loan}
            borrowerIds={borrowerIds}
            subjectPropertyIds={subjectPropertyIds}
            documentIds={documentIds}
          />
        </Box>
        <EnhancedCommentItemRenderer
          padding={0}
          sx={{ p: 2, width: "100%" }}
          loan={loan}
          comments={commentsList}
          suppressEmptyPlaceholder
        />
      </Flx>
    </Card>
  );
};

export default PinnedCommentsModal;
